import BackButton from "../library/BackButton"
import CaseStudySwitcher from "../library/CaseStudySwitcher"
import ProfileWidget from "../library/ProfileWidget"
import Mission from "./Mission"
import Problem from "./Problem"
import Constraints from "./Constraits"
import Process from "./Process"
import Users from "./Users"
import VersionControl from "./VersionControl"
import Generations from "./Generations"
import Results from "./Results"
import Learnings from "./Learnings"
import SectionHeader from "../library/SectionHeader"
import CaseStudy from "../Home/CaseStudy"


function AIManualReviewTool(props) {
    return (
        <div style={{width: "100%"}}>

            <BackButton />
            <CaseStudySwitcher current="AIManualReviewTool" />
            <ProfileWidget />

            {/* Hero */}
            <div className="sectionOuter">
                <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "64px", marginTop: "-24px"}}>
                    <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "24px", maxWidth: "800px"}}>
                        <div className="h1"> AI Manual Review Tool </div>
                        <div className="b1 center"> What if Yerbba employees could review AI-generated reports all in one screen? </div>
                        <div className="l1"> @Yerbba </div>
                    </div>
                </div>
                <div className="heroImages">
                    <img className="imgStyle" src="/Manual-Review.png" alt="report" width="100%" height="auto" />
                    <img className="imgStyle" src="/manReview/Prod-Users-Page.png" alt="compare" width="100%" height="auto" />
                    <img className="imgStyle" src="/manReview/Change-Log.png" alt="options" width="100%" height="auto" />
                </div>
            </div>

            <Mission />
            <Problem />
            <Constraints />
            <Process />
            <Users />
            <VersionControl />
            <Generations />
            <Results />
            <Learnings />

            <div className="sectionOuter">
                <SectionHeader
                    label="Next Up"
                    title="Check out another case study"
                    center={true}
                />
                <CaseStudy
                    img="/signup/Yerbba-Signup.png"
                    title="EHR Sign Up"
                    desc="Creating a trustworthy sign up flow that encourages patients to give access to their electronic health records"
                    page="EHRSignup"
                />
            </div>

        </div>
    )
}

export default AIManualReviewTool